"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  transparent: 'rgba(0,0,0,0)',
  white: '#ffffff',
  black: '#000000',
  paleGrey: '#e3e5ed',
  lightGrey: '#d5d7d8',
  midGrey: '#9b9ea0',
  paleBlue: '#89b6fa',
  lightBlue: '#3c4880',
  midBlue: '#2c3d6d',
  darkBlue: '#202e5b',
  brightBlue: '#77a5ff',
  midGreen: '#4daa50',
  lightPink: '#ffd5da',
  pink: '#aa4da8',
  midRed: '#ff3c55',
  teal: '#4da7aa',
  orange: '#f59600',
  purple: '#a88bd1',
  charcoal: '#1d1e20',
  graphite: '#282a2e',
  danger: '#ff3c55',
  warning: '#f59600',
  success: '#4daa50',
  info: '#202e5b',
  listItem1: '#4da7aa',
  listItem2: '#F59600',
  listItem3: '#aa4da8',
  listItem4: '#9b9ea0',
  listItem5: '#8c66c3',
  listItem6: '#7abdc0',
  listItem7: '#eba537',
  listItem8: '#c07abe',
  listItem9: '#b4b7b8',
  listItem10: '#a98dd2',
  listItem11: '#a6d3d4',
  listItem12: '#faca7f',
  listItem13: '#d4a6d3',
  listItem14: '#bbbfcd',
  listItem15: '#a98dd2'
};
exports.default = _default;